<template lang="pug">
    section#imagemELegendas
        Imagem(:content="content.image")
        ul(ref="items").items
            li
                h3 {{ content.titulo }}
            li(v-for="item, index in content.topics").item
                p {{ item.topico }}
</template>

<script>
import { components } from '@/mixins/components'

export default {
    name: "component-imagem-e-legendas",
    components,
    props: {
        content: {
            type: Object,
            required: true
        },
    },
}
</script>

<style lang="stylus" scoped src="./ImagemELegendas.styl"></style>